import React, { createContext, useState, useEffect } from "react";
import {jwtDecode} from "jwt-decode";
import axios from "axios";

export const context = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem("token");
    return storedToken || null;
  });

  const [user, setUser] = useState(() => {
    const storedToken = localStorage.getItem("token");
    const decoded = storedToken && jwtDecode(storedToken);
    return storedToken && ({ id: decoded.id, rol: decoded.rol, email: decoded.email } || null);
  });

  const handleLogin = (newToken) => {
    setToken(newToken);
    const decoded = jwtDecode(newToken);
    setUser({id: decoded.id, rol: decoded.rol, email: decoded.email, empresa: decoded.empresa });
    localStorage.setItem("token", newToken);
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem("token");
  };

  useEffect(() => {
    async function FetchPermissions() {
      try{
        if (!!token) {
          const decoded = jwtDecode(token); 
          const url = process.env.REACT_APP_ENVIRONMENT === "local" ? `http://localhost:${process.env.REACT_APP_PORT}` : process.env.REACT_APP_API_URL;
          const permissions = await axios.get(`${url}/api/v1/roles-permisos?rol=${decoded.rol}`, {headers: { Authorization: `Bearer ${token}` }});
          setUser({id: decoded.id, email: decoded.email, rol: permissions.data, empresa: decoded.empresa});
        }
      }catch(e){
        if (!!e.response) {
          if(!!e.response.data.error){
            handleLogout();
          }
        }
      }
    }
    FetchPermissions();
  }, [token]);


  const [showSideMenu, setShowSideMenu] = useState(false);

  const handleShowSideMenu = () => setShowSideMenu(true);
  const handleCloseSideMenu = () => setShowSideMenu(false);

  useEffect(() => {
    // No hagas nada en este efecto, solo se ejecuta una vez al inicio
  }, []);

  return (
    <context.Provider
      value={{
        token,
        user,
        handleLogin,
        handleLogout,
        showSideMenu,
        handleShowSideMenu,
        handleCloseSideMenu,
      }}
    >
      {children}
    </context.Provider>
  );
}
